<template>
  <panel :title="title">
    <div class="row">
      <div class="form-group col-12">
        <w-input :model="$schema.name" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.mask" />
      </div>

      <div class="form-group col-12">
        <w-monaco language="html" :model="$schema.body" />
      </div>

      <div class="form-group col-12">
        <w-vue-select label-field="name" value-field="id" :model="$schema.schemaId" :values="schemas" />
      </div>

      <div class="col-12">
        <h3>Drukowanie</h3>

        <div class="row">
          <div class="col-6">
            <w-vue-select class="col-12 form-group" :model="$schema.headerId" :values="views" />

            <!-- Wykomentowane do czasu naprawy PDF renderera -->
            <!-- <yes-or-no class="col-12 form-group" :model="$schema.hideHeaderOnFirstPage" /> -->
          </div>

          <div class="col-6">
            <w-vue-select class="col-12 form-group" :model="$schema.footerId" :values="views" />

            <!-- Wykomentowane do czasu naprawy PDF renderera -->
            <!-- <yes-or-no class="col-12 form-group" :model="$schema.hideFooterOnFirstPage" /> -->
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="row">
      <div class="col-md-12">
        <button class="btn btn-secondary float-left" @click="cancel">
          Wróć
        </button>

        <button class="btn btn-primary float-right" @click="save">
          Zapisz
        </button>
      </div>
    </div>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

// import YesOrNo from '@/components/forms/document/YesOrNoRadio.vue';
import Panel from '@/components/panel/Panel';
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { formViewMixin } from '@/mixins/formView';
import schema from '@/schemas/view.schema';

const emptyData = () => ({
  name: null,
  body: null,
  headerId: null,
  hideHeaderOnFirstPage: false,
  footerId: null,
  hideFooterOnFirstPage: false,
  schemaId: null
});
const messages = {
  listError: Errors.VIEW_CANNOT_LIST,
  getError: Errors.VIEW_CANNOT_GET,
  added: Successes.VIEW_ADDED,
  addError: Errors.VIEW_ADD_ERROR,
  updated: Successes.VIEW_UPDATED,
  updateError: Errors.VIEW_UPDATE_ERROR,
  deleteConfirm: Successes.VIEW_CONFIRM_DELETE,
  deleted: Successes.VIEW_DELETED,
  deleteError: Errors.VIEW_DELETE_ERROR
};

export default {
  components: { Panel /*, YesOrNo*/ },
  mixins: [formViewMixin('view', messages, emptyData)],
  schema,
  computed: {
    title() {
      return this.edit ? 'Edycja widoku' : 'Dodawanie widoku';
    },
    ...mapState({
      views(state) {
        return state.view.list
          .filter(view => view.id !== state.view.data?.id)
          .map(view => ({ value: view.id, text: view.name }));
      },
      schemas: state => state.schema.list
    })
  },

  methods: {
    // @vuese
    // Funkcja wykonywana po zapisie
    afterSave(data) {
      this.$emit('saved', data);
    }
  }
};
</script>
